import { CategoryDetailsPageContext } from "@eisinc/Overrides/Pages/CategoryDetailsPage";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import widgetModule from "@insite/content-library/Widgets/ProductList/ProductListPriceFilters";

widgetModule.definition.allowedContexts = [ProductListPageContext, CategoryDetailsPageContext];

export default widgetModule;
